var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.66663V9.99996C12.5 10.9166 11.75 11.6666 10.8333 11.6666H1.66663V6.34996C2.27496 7.07496 3.20831 7.52496 4.24165 7.49996C5.08331 7.48329 5.84163 7.15829 6.40829 6.61663C6.66663 6.39996 6.88331 6.12495 7.04998 5.82495C7.34998 5.31662 7.51663 4.7166 7.49996 4.0916C7.47496 3.1166 7.04164 2.25829 6.36664 1.66663H12.5Z",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.6666V14.1666C18.3333 15.55 17.2166 16.6666 15.8333 16.6666H15C15 15.75 14.25 15 13.3333 15C12.4166 15 11.6666 15.75 11.6666 16.6666H8.33329C8.33329 15.75 7.58329 15 6.66663 15C5.74996 15 4.99996 15.75 4.99996 16.6666H4.16663C2.78329 16.6666 1.66663 15.55 1.66663 14.1666V11.6666H10.8333C11.75 11.6666 12.5 10.9166 12.5 9.99996V4.16663H14.0333C14.6333 4.16663 15.1833 4.49163 15.4833 5.0083L16.9083 7.49996H15.8333C15.375 7.49996 15 7.87496 15 8.33329V10.8333C15 11.2916 15.375 11.6666 15.8333 11.6666H18.3333Z",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.3333C7.58714 18.3333 8.33333 17.5871 8.33333 16.6667C8.33333 15.7462 7.58714 15 6.66667 15C5.74619 15 5 15.7462 5 16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333Z",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.3333C14.2538 18.3333 15 17.5871 15 16.6667C15 15.7462 14.2538 15 13.3333 15C12.4128 15 11.6666 15.7462 11.6666 16.6667C11.6666 17.5871 12.4128 18.3333 13.3333 18.3333Z",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10V11.6667H15.8333C15.375 11.6667 15 11.2917 15 10.8333V8.33333C15 7.875 15.375 7.5 15.8333 7.5H16.9083L18.3333 10Z",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 4.0917C7.51669 4.7167 7.35004 5.31672 7.05004 5.82505C6.88337 6.12505 6.66669 6.40006 6.40836 6.61673C5.84169 7.15839 5.08338 7.48339 4.24171 7.50006C3.20838 7.52506 2.27502 7.07505 1.66669 6.35005C1.55002 6.22505 1.45003 6.08339 1.35836 5.94173C1.03336 5.45006 0.850021 4.86675 0.833354 4.24175C0.808354 3.19175 1.27501 2.23338 2.02501 1.60838C2.59168 1.14172 3.30833 0.850057 4.09167 0.833391C4.96667 0.816724 5.7667 1.13339 6.3667 1.66672C7.0417 2.25839 7.47502 3.1167 7.50002 4.0917Z",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8667 4.19173L3.70837 4.9917L5.45001 3.30835",
    stroke: "#7F57F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.a87c176fcece5964317c5eb57be29108.svg";
export { ForwardRef as ReactComponent };